export default __webpack_public_path__ + "img/signal_disconnected.7b519f71323c1da24944bd84f6035412.svg";